module.exports = __webpack_public_path__ + "img/instagram-circle.5e1ab9f4.svg";